import React from "react";

export function fmt$(v, d = 2) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (isNaN(n)) return "—";
  return (n < 0 ? "-$" : "$") + Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function fmtPct(v, d = 1) {
  if (v == null) return "—";
  return Number(v).toFixed(d) + "%";
}

export function fmtN(v, d = 2) {
  if (v == null) return "—";
  return Number(v).toFixed(d);
}

// Paper money format — Zi Learning currency (not real USD)
export function fmtZi$(v, d = 2) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (isNaN(n)) return "—";
  return (n < 0 ? "-z$" : "z$") + Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export const ZI_PAPER_BADGE = ({ style }) => <span style={{ fontSize: 8, padding: "1px 5px", borderRadius: 3, background: "rgba(167,139,250,0.15)", color: "#a78bfa", fontWeight: 600, letterSpacing: 0.5, ...style }}>ZI PAPER</span>;

// Parse OCC option symbol (e.g., "AAL260417C00012500") into readable format
export function parseOCC(sym) {
  const m = sym?.match(/^([A-Z]+)(\d{2})(\d{2})(\d{2})([CP])(\d{8})$/);
  if (!m) return null;
  const [, ticker, yy, mm, dd, cp, rawStrike] = m;
  const strike = parseInt(rawStrike, 10) / 1000;
  const side = cp === "C" ? "Call" : "Put";
  const expDate = `${parseInt(mm)}/${parseInt(dd)}/${yy}`;
  return { ticker, strike, side, expDate, display: `${ticker} $${strike} ${side} ${expDate}` };
}

export function ziClass(score) {
  if (score >= 81) return "zi-h";
  if (score >= 66) return "zi-m";
  return "zi-l";
}

export function colorVal(val) {
  const n = typeof val === "string" ? parseFloat(val.replace(/[^0-9.-]/g, "")) : val;
  if (isNaN(n)) return null;
  return n >= 0 ? "pos" : "neg";
}

// Watch/position recommended-action → color. Single source of truth — this used
// to be copy-pasted separately in Positions.js, AccountTab.js's OpenPositionModal,
// and AccountTab.js's WatchRoomModal, and two of the three copies had drifted
// (OpenPositionModal rendered HOLD blue and EXIT bright red while the other two
// rendered HOLD green and EXIT muted red), so the same "HOLD" action showed a
// different color depending on which modal happened to be open.
export const ACTION_COLORS = {
  "HOLD": "#22c55e", "TRAIL STOP": "#4ade80", "SCALE OUT": "#4ade80",
  "TIGHTEN RISK": "#fbbf24", "EVALUATE EXIT": "#f87171", "EXIT": "#f87171",
};
